import React, { useState, useEffect } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import "../../../assets/css/Buyer/General/navbar.css";
import { Link } from "react-router-dom";
import logo from "../../../assets/images/logo.png";

function MyNavbar({ type }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled]             = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const closeMobileMenu = () => setMobileMenuOpen(false);

  return (
    <>
      <nav
        style={{ backgroundColor: type === "nosticky" ? "#000000" : "" }}
        className={
          type === "nosticky"
            ? "navbar navbar-dark"
            : `navbar ${scrolled ? "navbar-scrolled" : ""}`
        }
      >
        <div className="navbar-container">

          {/* ── LEFT — Logo + Brand text + Tagline ── */}
          <a href="/" className="navbar-brand">
            <img src={logo} alt="Estate Experts" className="navbar-logo" />

            {/* Text block */}
            <div className="navbar-brand-text-wrap">
              <span className="brand-text">Estate Experts</span>
              <span className="brand-tagline">
                Buy
                <span className="brand-tagline-dot">◆</span>
                Sell
                <span className="brand-tagline-dot">◆</span>
                Rent
              </span>
            </div>
          </a>

          {/* ── CENTER — Nav links ── */}
          <div className="navbar-center">
            <a href="/buyer/signup" className="nav-link">Buy</a>
            <a href="/seller/signup" className="nav-link">Sell</a>
          </div>

          {/* ── RIGHT — Hamburger ── */}
          <div className="navbar-right">
            <button
              className="icon-btn"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              {mobileMenuOpen ? <FaTimes /> : <FaBars />}
            </button>
          </div>

        </div>
      </nav>

      {/* ── Mobile Menu ── */}
      <div className={`mobile-menu ${mobileMenuOpen ? "mobile-menu-open" : ""}`}>
        <Link to="/"           className="mobile-menu-item" onClick={closeMobileMenu}>Home</Link>
        <Link to="/properties" className="mobile-menu-item" onClick={closeMobileMenu}>Properties</Link>
        <Link to="/agents"     className="mobile-menu-item" onClick={closeMobileMenu}>Agents</Link>
        <Link to="/about"      className="mobile-menu-item" onClick={closeMobileMenu}>About</Link>
        <Link to="/blogs"      className="mobile-menu-item" onClick={closeMobileMenu}>Blogs</Link>
        <Link to="/contact"    className="mobile-menu-item" onClick={closeMobileMenu}>Contact Us</Link>

        <div className="mobile-auth">
          <a href="/buyer/dashboard" className="mobile-dashboard-btn Buyer-btn">Buy</a>
          <a href="/seller/login"    className="mobile-dashboard-btn Seller-btn">Sell</a>
        </div>
      </div>
    </>
  );
}

export default MyNavbar;